module.exports = ".modal {\n    background: rgba(0, 0, 0, 0.52);\n}\n.modal-dialog {\n    width: 91%\n}\n.modal-body {\n    width: 100%\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/pop-up-details-demande/pop-up-details-demande.component.css
// module id = ./src/app/shared/pop-up-details-demande/pop-up-details-demande.component.css
// module chunks = main